module.exports = __webpack_public_path__ + "img/2_x4.c6257dc4.png";